import { defineComponent } from "../../../common/runtime/defineComponent.svelte.ts";
import type { Props } from "./SkeletonV1.types.ts";
import { observeNearViewport } from "../../../common/utils/observeNearViewport.ts";

defineComponent<Props>({
  tag: "oc-skeleton-v1",
  extendOptions: { useShadow: false },
  props: {
    variant: { type: "String", reflect: true },
    hidden: { type: "Boolean", reflect: true },
    width: { type: "String" },
    height: { type: "String" },
    borderRadius: { type: "String", attribute: "border-radius" },
  },
  styles: () => import("./SkeletonV1.global.scss?inline"),
  onMount: (host) => {
    /*                                                                                                         */
    /*                         */
    const circle = host.variant === "circle";
    if (host.width) host.style.width = host.width;
    if (host.height && !circle) host.style.height = host.height;
    if (host.borderRadius && !circle) host.style.borderRadius = host.borderRadius;

    return observeNearViewport(host);
  },
});
